import React from "react";
import { Grid } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import FeedbackIcon from "@mui/icons-material/Feedback";
import DashboardCard from "../../components/DashboardCard";

const AdminDashboard = () => {
  const cardData = [
    {
      title: "Users Management",
      description: "Create and Manage Business Owners.",
      buttonLabel: "View Users",
      icon: <PeopleIcon />,
      color: "#00796b",
      route: "/admin/users",
    },
    {
      title: "View Detailed Feedbacks",
      description: "Analyze business-related feedback from employees.",
      buttonLabel: "View Feedbacks",
      icon: <FeedbackIcon />,
      color: "#d32f2f",
      route: "/admin/feedbacks",
    },
    {
      title: "Feedback Reports",
      description: "Access feedback summaries.",
      buttonLabel: "View Reports",
      icon: <BarChartIcon />,
      color: "#388e3c",
      route: "/admin/reports",
    },
  ];

  return (
    <Grid container spacing={4} justifyContent="center">
      {cardData.map((card, index) => (
        <DashboardCard key={index} {...card} />
      ))}
    </Grid>
  );
};

export default AdminDashboard;
